import axios from "axios";
import { SET_APPLIED_PERMISSIONS, SET_USER_LOGIN } from '../actions/types'
import store from '../helpers/store';

const API_URL = "/api/v1/";

const login = (userId, password, authnAttemptId, rsaInitialiseMessageId, rsaAuthnAttemptId) => {
    return axios
        .post(API_URL + "login/2-factors", {
            userId,
            password,
            authnAttemptId,
            rsaInitialiseMessageId,
            rsaAuthnAttemptId
        })
        .then((response) => {
            if (response && response.data && response.data.user) {
                let flattened = response?.data?.privs?.flat().filter(x => x !== null);
                let final = [];
                for (let i = 0; i < flattened.length; i++) {
                    final.push({ key: flattened[i].rolPriPageId, value: flattened[i].rolPriPrivileges })
                }
                let sorted = final.sort((a, b) => a.key - b.key);
                store.dispatch({
                    type: SET_APPLIED_PERMISSIONS,
                    payload: sorted,
                });
                store.dispatch({
                    type: SET_USER_LOGIN,
                    payload: response.data.user,
                });
                localStorage.setItem("user", JSON.stringify(response.data.user));
                localStorage.setItem("permissions", JSON.stringify(sorted));
            }
            return response.data;
        });
};
const loginInitialise = (userId, password) => {
    return axios
        .post(API_URL + "login/initialise", { userId, password })
        .then((response) => {
            return response.data;
        });
};
const cancelDoubleAuthentification = ( authnAttemptId ) => {
    localStorage.removeItem("oidc");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
    return axios
        .post(API_URL + "login/cancel", { authnAttemptId })
};
const logout = () => {
    localStorage.removeItem("oidc");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
    return axios
        .post(API_URL + "user/logout")
};


const allActions = {
    login,
    logout,
    loginInitialise,
    cancelDoubleAuthentification,
};

export default allActions;